import { Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { endpoints } from '../../../../../environments/endpoints';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  isLoading = signal<boolean>(false);

  loginWithMicrosoft(): void {
    this.isLoading.set(true);

    try {
      window.location.href = `${environment.coreApi.host}/${endpoints.auth.loginRedirect}`;
    } catch (error) {
      console.error('Navigation error:', error);
      this.isLoading.set(false);
    }
  }
}
